import React from 'react'
import ChatBot from "./ChatBot";

function Social() {
  return (
    <div>
      <h1>Under testing and Development. Launching in a few</h1>
      <ChatBot />

    </div>
  )
}

export default Social